
import { defineComponent, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router';
import KTFile from "@/components/files/File.vue";
import { errManager } from "@/core/config/Tools";
import MultimediaService from '@/core/services/MultimediaService'
import { useI18n } from "vue-i18n/index";
import GlobalService from '@/core/services/GlobalService';

export default defineComponent({
    name: "acrd-documents",
    components: { KTFile },
    setup() {
        const { t } = useI18n();
        const loader = ref(false)
        const route = useRoute();
        const { id } = route.params
        const listDocs = ref<any>([])
        
        const getData = async() => {
            loader.value = true
            await GlobalService.post("multimedia", {idevent: id, tabla: 'events'})
            .then((res)=>{
                listDocs.value = res.data
                loader.value = false
            }).catch(({response})=>{
                loader.value = false
                errManager(response)
            })
        }

        onMounted(()=>{
            getData()
        })

        return {
            t,
            loader,
            listDocs,
            getData
        }
    },
})
